import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilChartLine, cilClearAll, cilPencil, cilReload } from '@coreui/icons'
import SearchTable from 'src/components/searchTable'
import { activeArray, checkPermissions, raiseToast } from 'src/views/utils/helper'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown, faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import { GlobalContext } from 'src/views/context/GlobalState'
// import CreateCmsUser from './createCmsUser
import { AppContext } from '../../../context/app'
import { PERMISSIONS } from '../../../utils/permissions'
import { ROLE_LIST_API, USER_API } from '../../../utils/urls'
import useAxios from 'axios-hooks'
import LeadPartnerModal from './leadPartnerModal'
import ResetPasswordModal from '../../userManagement/common/resetPasswordModal'
import getSymbolFromCurrency from 'currency-symbol-map'
import { isEmpty } from 'lodash'
import { useHistory } from 'react-router-dom'

const LeadPartner = () => {
  const { userObj, userSessionObj } = useContext(GlobalContext)
  const { setLoader } = useContext(AppContext)
  const history = useHistory()

  const [rolesList, setRolesList] = useState([])
  const [selectedPartner, setSelectedPartner] = useState({})

  const [partnerList, setPartnerList] = useState([])

  const [openModal, setOpenModal] = useState(false)
  const [partnerStatusModal, setPartnerStatusModal] = useState(false)
  const [resetPasswordModal, setResetPasswordModal] = useState(false)

  const createAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.CUSTOM_FORMS.CREATE,
  )
  const updateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.CUSTOM_FORMS.UPDATE,
  )

  const [{ data: roleList, loading: roleListLoading }, roleListCall] = useAxios(
    {
      url: ROLE_LIST_API,
      method: 'get',
    },
    { manual: true },
  )
  const [{ data: leadPartnerList, loading: leadPartnerListLoading }, leadPartnerListCall] =
    useAxios(
      {
        url: `${USER_API}/lead-partner`,
        method: 'get',
      },
      { manual: true },
    )

  const [{ data: createPartner, loading: createPartnerLoading }, createPartnerCall] = useAxios(
    {
      url: `${USER_API}/lead-partner`,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: updatePartner, loading: updatePartnerLoading }, updatePartnerCall] = useAxios(
    {
      url: `${USER_API}/lead-partner`,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    roleListCall()
    leadPartnerListCall()
  }, [])

  useEffect(() => {
    setLoader(
      roleListLoading || leadPartnerListLoading || createPartnerLoading || updatePartnerLoading,
    )
  }, [roleListLoading, leadPartnerListLoading, createPartnerLoading, updatePartnerLoading])

  useEffect(() => {
    if (roleList && roleList.success && leadPartnerList && leadPartnerList.success) {
      let tempPartner = []
      let tempArr = roleList.data.filter(
        (ele) => ele.name !== 'Subscriber' && ele.name !== 'Account Admin',
      )
      leadPartnerList.data.forEach((ele) => {
        let roleString = ''

        let { roles } = ele

        roles.forEach((element, index) => {
          const roleObj = roleList.data.find((role) => role._id === element)
          if (roleObj) {
            roleString += `${roleObj.name}${index < roles.length - 1 ? ',' : ''} `
          }
        })

        if (userObj._id !== ele._id) {
          tempPartner.push({ ...ele, roleName: roleString })
        }
      })
      setPartnerList(tempPartner)

      setRolesList(activeArray(tempArr))
    }
  }, [roleList, leadPartnerList])

  useEffect(() => {
    if (createPartner && createPartner.success) {
      leadPartnerListCall()
      raiseToast('success', 'Lead Partner created successfully')
    }
  }, [createPartner])

  useEffect(() => {
    if (updatePartner && updatePartner.success) {
      setPartnerStatusModal(false)
      setSelectedPartner({})
      leadPartnerListCall()
      raiseToast('success', 'Lead Partner updated successfully')
    }
  }, [updatePartner])

  const handleEdit = (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedPartner(info)
    setOpenModal(true)
  }

  const handleAdd = () => {
    if (!createAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedPartner({})
    setOpenModal(!openModal)
  }

  const addPartner = (payload) => {
    createPartnerCall({
      data: payload,
    })
    setOpenModal(false)
  }

  const editPartner = (id, payload) => {
    updatePartnerCall({
      params: {
        user_id: id,
      },
      data: payload,
    })
    setOpenModal(false)
  }

  const handleActivateDeactivate = (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedPartner(info)
    setPartnerStatusModal(true)
  }

  const handleResetPassword = (info) => {
    if (!updateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedPartner(info)
    setResetPasswordModal(true)
  }

  const handleStatus = async (info) => {
    updatePartnerCall({
      params: {
        user_id: info?._id,
      },
      data: {
        status: !info.status,
      },
    })
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 17,
    },
    {
      header: 'Email',
      dataCell: (info) => info.email_id,
      width: 20,
    },
    {
      header: 'Roles',
      dataCell: (info) => info.roleName,
      width: 24,
    },
    {
      header: 'Per Lead Price',
      dataCell: (info) =>
        !isEmpty(info?.lead_user_meta)
          ? getSymbolFromCurrency(info?.lead_user_meta.currency) +
            info?.lead_user_meta?.revenue_share
          : 'N/A',
      width: 24,
    },
    {
      header: 'Status',
      dataCell: (info) => (info.status ? 'Active' : 'In Active'),
      width: 11,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 13,
    },
    {
      header: (
        <div className="d-flex justify-content-center">
          <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />
        </div>
      ),
      dataCell: (info) => (
        <div className="d-flex justify-content-center">
          <CDropdown>
            <CDropdownToggle color="white" caret={false}>
              <FontAwesomeIcon icon={faEllipsisH} size="2x" />
            </CDropdownToggle>
            <CDropdownMenu>
              <CDropdownItem
                onClick={() => history.push('/custom-forms/lead-partner/analytics/' + info['_id'])}
              >
                <CIcon icon={cilChartLine} size="sm" />
                {' Detail Analytics'}
              </CDropdownItem>
              <CDropdownItem onClick={() => handleEdit(info)}>
                <CIcon icon={cilPencil} size="sm" />
                {'  Edit'}
              </CDropdownItem>
              <CDropdownItem onClick={() => handleResetPassword(info)}>
                <CIcon icon={cilReload} size="sm" />
                {'  Reset Password'}
              </CDropdownItem>
              <CDropdownItem onClick={() => handleActivateDeactivate(info)}>
                <CIcon icon={cilClearAll} size="sm" />
                {!info.status ? ' Activate' : ' Deactivate'}
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </div>
      ),
      width: 10,
    },
  ]
  return (
    <>
      <h4>Lead Partners</h4>
      <p>{`Manage your Lead Partners`}</p>
      <SearchTable
        type={`Lead Partners`}
        tableCardHeight={65}
        disableButton={false}
        buttonName={`+ Add`}
        buttonFunction={handleAdd}
        searchTerm={`name`}
        tableConfig={tableConfig}
        tableContent={partnerList}
        createPermission={createAllowed}
      />
      {openModal && (
        <LeadPartnerModal
          openModal={openModal}
          onCancel={() => setOpenModal(false)}
          setOpenModal={setOpenModal}
          roleData={rolesList}
          partnerData={selectedPartner}
          addCallback={addPartner}
          editCallback={editPartner}
        />
      )}
      {resetPasswordModal && (
        <ResetPasswordModal
          user={selectedPartner}
          showModal={resetPasswordModal}
          handleClose={() => setResetPasswordModal(false)}
        />
      )}
      {partnerStatusModal && (
        <CModal
          size="md"
          visible={true}
          alignment="center"
          onClose={() => setPartnerStatusModal(false)}
        >
          <CModalHeader closeButton>
            {selectedPartner.status ? 'Deactivate' : 'Activate'} {selectedPartner.name}
          </CModalHeader>
          {selectedPartner.status && (
            <CModalBody>
              After deactivation Partner will not able to login.
              <br /> Do you want to deactivate?
            </CModalBody>
          )}
          {!selectedPartner.status && <CModalBody>Do you want to activate the Partner?</CModalBody>}
          <CModalFooter>
            <CButton color="primary" onClick={() => handleStatus(selectedPartner)}>
              {selectedPartner.status ? 'Deactivate' : 'Activate'}
            </CButton>{' '}
            <CButton color="secondary" onClick={() => setPartnerStatusModal(false)}>
              Cancel
            </CButton>
          </CModalFooter>
        </CModal>
      )}
    </>
  )
}

export default LeadPartner
